export let process = {
  cwd: () => '',
  env: () => {}
}

export let global = {}
